import React from 'react';
import Icon from '../../../../../../../../../helper/Icon';

export default (props) => {
  const lesson = props.lesson;
  const item = lesson.items[0];

  const settings = lesson.settings;

  const { paddingBottom, paddingTop } = settings;

  const style = {
    paddingBottom: paddingBottom * 10,
    paddingTop: paddingTop * 10
  };

  return (
    <div style={style}>
      <div className="block-text--onecol">
        <div className="block-text__container">
          <div className="block-text__row">
            <div className="block-text__col">
              <a
                className="block-attachment"
                href={item.media.attachment.src}
                download={item.media.attachment.fileName}
                target="_blank"
              >
                <div className="block-attachment__main">
                  <div className="block-attachment__icon">
                    <svg
                      viewBox="0 0 40 50"
                      width="40"
                      height="50"
                      className="svgIcon svgIcon--file"
                    >
                      <g>
                        <g>
                          <path
                            d="M2.00804893,0 C0.899034128,0 0,0.889064278 0,1.99091407 L0,48.0090859 C0,49.1086374 0.892756032,50 1.99862555,50 L37.2170607,50 C38.3208711,50 39.2156863,49.1011186 39.2156863,47.993136 L39.2156863,13.6363636 L26.1437908,0 L2.00804893,0 Z"
                            opacity="0.205748601"
                          />
                          <path
                            d="M26.1437908,0 L26.1437908,11.7296861 C26.1437908,12.8319383 27.0422752,13.7254902 28.1433598,13.7254902 L39.2156863,13.7254902"
                            opacity="0.25"
                          />
                        </g>
                        <path d="M13.5335,22.9865 L13.5335,24.4165 L10.2445,24.4165 L10.2445,26.446 L12.9835,26.446 L12.9835,27.8815 L10.2445,27.8815 L10.2445,31 L8.3745,31 L8.3745,22.9865 L13.5335,22.9865 Z M17.0365,31 L15.1665,31 L15.1665,22.9865 L17.0365,22.9865 L17.0365,31 Z M20.8805,29.515 L23.8505,29.515 L23.8505,31 L19.0215,31 L19.0215,22.9865 L20.8805,22.9865 L20.8805,29.515 Z M30.3895,22.9865 L30.3895,24.4165 L27.1005,24.4165 L27.1005,26.2865 L29.6195,26.2865 L29.6195,27.6615 L27.1005,27.6615 L27.1005,29.57 L30.3895,29.57 L30.3895,31 L25.2305,31 L25.2305,22.9865 L30.3895,22.9865 Z" />
                      </g>
                    </svg>
                  </div>
                  <div className="block-attachment__info brand--head">
                    <div className="block-attachment__title">{item.media.attachment.fileName}</div>
                    <div className="block-attachment__size">
                      {item.media.attachment.fileSize}
                      {' '}
bytes
                    </div>
                  </div>
                </div>
                <div className="block-attachment__rest">
                  <Icon icon="download-1" fill="#87898b" size="19px" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
